import type { SearchableSelectOption } from '@folio/components/ui/searchable-select';
import {
  getStopReasonUnavailability,
  isStopReasonAllowedTo,
  type StopReasonPolicyDates,
  type StopReasonUnavailability,
} from '@folio/utils/stop-reasons';
import type { ConfigPolicyStopReasonDto } from 'korint-sdk';

export type TranslateReason = {
  label(reason: string): string;
  description(reason: string): string;
  unavailable(unavailability: StopReasonUnavailability): string;
};

// A reason the backend would reject stays listed but disabled, its cause replacing the description.
export const buildReasonOptions = ({
  reasons,
  policy,
  businessRoleId,
  translate,
}: {
  reasons: ConfigPolicyStopReasonDto[];
  policy: StopReasonPolicyDates;
  businessRoleId?: string;
  translate: TranslateReason;
}): SearchableSelectOption[] =>
  reasons
    .filter(reason => isStopReasonAllowedTo({ reason, businessRoleId }))
    .map(reason => {
      const unavailability = getStopReasonUnavailability({ reason, policy });
      return {
        value: reason.reason,
        label: translate.label(reason.reason),
        description: unavailability
          ? translate.unavailable(unavailability)
          : translate.description(reason.reason),
        disabled: !!unavailability,
      };
    });
